import {Component, HostListener} from '@angular/core';
import {CommonService} from '../services/common.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent {

  constructor(private commonService: CommonService) {}
  @HostListener('window:scroll', ['$event'])
  scrollHandler() {
    this.commonService.manageStickyHeader('policyPageHeader');
  }
}
